import React from 'react';
import SupportAccordian from '../SharedTemplates/SupportAccordian';

const HamburgerSupportSection = props => {
  const { categoryHeaderText, subCategories, onClickHandler } = props;

  return (
    <div className='ul-title'>
      <span role='heading' aria-level='2' className='header-text-footer'>
        {categoryHeaderText}
      </span>
      <SupportAccordian subCategories={subCategories} onClickHandler={onClickHandler} />
    </div>
  );
};
export { HamburgerSupportSection };
